import axios from 'axios';
import { ENDPOINTS } from '@/settings/endpoints';

export class PegasusMustangClient {
  private static requestClient = axios.create({
    baseURL: ENDPOINTS.pegasusMustangUrl,
  });

  static async request(requestInformation: {
    method: string;
    requestURL: string;
    params?: any;
    bodyData?: any;
  }) {
    const token = localStorage.getItem('token');

    return this.requestClient.request({
      method: requestInformation.method,
      url: requestInformation.requestURL,
      params: requestInformation.params,
      data: requestInformation.bodyData,
      headers: {
        'Authorization-Dex': `Bearer ${token}`,
        'Cache-Control': 'no-cache',
      },
    });
  }
}

export default PegasusMustangClient;
